import { getFormattedDateWithTime } from "components/common/Utility"

export const SupplierDestinationConfigColumnDef = [
    {
        headerName: "",
        checkboxSelection: true,
        headerCheckboxSelection: false, // Disable default "Select All" checkbox
        minWidth: 50,
        maxWidth: 80,
    },
    {
        headerName: "Supplier",
        field: "sourceId",
        filter: false,
        minWidth: 100,
        maxWidth: 120,
    },
    {
        headerName: "Destination",
        field: "destinationId",
        filter: false,
        minWidth: 100,
        maxWidth: 120,
    },
    {
        headerName: "Created By",
        field: "userId",
        filter: false,
    },
    {
        headerName: "Created At",
        valueGetter: (params) => {
            return getFormattedDateWithTime(params.data.createdAt)
        },
        filter: false,
    }
]